// extracted by mini-css-extract-plugin
export default {"container":"qm2_MA"};